export default [
    {
        "updated_at": "2020-05-03 20:31:46",
        "id": 1948,
        "sales": 314,
        "image": "/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "value": "100.00",
        "deleted_at": null,
        "sort": 999,
        "status_text": "启用",
        "status": 1,
        "created_at": "2020-01-03 15:46:36",
        "desc": "1. 储值成功后，不可退款，请根据自己的消费情况充值。\n2. 储值余额不可提现，不可转移、转赠。\n3. 储值金额按国家法律、法规开具符合规定的发票，后续凭储值余额消费时，不再开具发票。如需发票请至奈雪点单小程序个人中心联系客服。\n4. 储值不累计会员成长值、积分与宝石，订单消费时以实际订单支付金额累计会员成长值、积分与宝石。\n5. 储值余额可在奈雪的茶内地线下门店、奈雪酒屋全国门店、奈雪点单小程序在线支付使用。",
        "store_id": 23107,
        "gifts": [],
        "type": 0,
        "full_image": "https://img-shop.qmimg.cn/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "name": "100元",
        "sell_price": "100.00"
    },
    {
        "updated_at": "2020-05-02 21:59:50",
        "id": 1972,
        "sales": 112,
        "image": "/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "value": "200.00",
        "deleted_at": null,
        "sort": 999,
        "status_text": "启用",
        "status": 1,
        "created_at": "2020-01-09 23:37:52",
        "desc": "1. 储值成功后，不可退款，请根据自己的消费情况充值。\n2. 储值余额不可提现，不可转移、转赠。\n3. 储值金额按国家法律、法规开具符合规定的发票，后续凭储值余额消费时，不再开具发票。如需发票请至奈雪点单小程序个人中心联系客服。\n4. 储值不累计会员成长值、积分与宝石，订单消费时以实际订单支付金额累计会员成长值、积分与宝石。\n5. 储值余额可在奈雪的茶内地线下门店、奈雪酒屋全国门店、奈雪点单小程序在线支付使用。",
        "store_id": 23107,
        "gifts": [],
        "type": 0,
        "full_image": "https://img-shop.qmimg.cn/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "name": "200元",
        "sell_price": "200.00"
    },
    {
        "updated_at": "2020-05-01 20:19:41",
        "id": 1973,
        "sales": 31,
        "image": "/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "value": "300.00",
        "deleted_at": null,
        "sort": 999,
        "status_text": "启用",
        "status": 1,
        "created_at": "2020-01-09 23:38:10",
        "desc": "1. 储值成功后，不可退款，请根据自己的消费情况充值。\n2. 储值余额不可提现，不可转移、转赠。\n3. 储值金额按国家法律、法规开具符合规定的发票，后续凭储值余额消费时，不再开具发票。如需发票请至奈雪点单小程序个人中心联系客服。\n4. 储值不累计会员成长值、积分与宝石，订单消费时以实际订单支付金额累计会员成长值、积分与宝石。\n5. 储值余额可在奈雪的茶内地线下门店、奈雪酒屋全国门店、奈雪点单小程序在线支付使用。",
        "store_id": 23107,
        "gifts": [],
        "type": 0,
        "full_image": "https://img-shop.qmimg.cn/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "name": "300元",
        "sell_price": "300.00"
    },
    {
        "updated_at": "2020-05-03 13:12:35",
        "id": 1974,
        "sales": 14,
        "image": "/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "value": "400.00",
        "deleted_at": null,
        "sort": 999,
        "status_text": "启用",
        "status": 1,
        "created_at": "2020-01-09 23:38:30",
        "desc": "1. 储值成功后，不可退款，请根据自己的消费情况充值。\n2. 储值余额不可提现，不可转移、转赠。\n3. 储值金额按国家法律、法规开具符合规定的发票，后续凭储值余额消费时，不再开具发票。如需发票请至奈雪点单小程序个人中心联系客服。\n4. 储值不累计会员成长值、积分与宝石，订单消费时以实际订单支付金额累计会员成长值、积分与宝石。\n5. 储值余额可在奈雪的茶内地线下门店、奈雪酒屋全国门店、奈雪点单小程序在线支付使用。",
        "store_id": 23107,
        "gifts": [],
        "type": 0,
        "full_image": "https://img-shop.qmimg.cn/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "name": "400元",
        "sell_price": "400.00"
    },
    {
        "updated_at": "2020-04-18 07:43:07",
        "id": 1975,
        "sales": 7,
        "image": "/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "value": "600.00",
        "deleted_at": null,
        "sort": 999,
        "status_text": "启用",
        "status": 1,
        "created_at": "2020-01-09 23:38:44",
        "desc": "1. 储值成功后，不可退款，请根据自己的消费情况充值。\n2. 储值余额不可提现，不可转移、转赠。\n3. 储值金额按国家法律、法规开具符合规定的发票，后续凭储值余额消费时，不再开具发票。如需发票请至奈雪点单小程序个人中心联系客服。\n4. 储值不累计会员成长值、积分与宝石，订单消费时以实际订单支付金额累计会员成长值、积分与宝石。\n5. 储值余额可在奈雪的茶内地线下门店、奈雪酒屋全国门店、奈雪点单小程序在线支付使用。",
        "store_id": 23107,
        "gifts": [],
        "type": 0,
        "full_image": "https://img-shop.qmimg.cn/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "name": "600元",
        "sell_price": "600.00"
    },
    {
        "updated_at": "2020-04-29 19:48:32",
        "id": 1976,
        "sales": 18,
        "image": "/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "value": "800.00",
        "deleted_at": null,
        "sort": 999,
        "status_text": "启用",
        "status": 1,
        "created_at": "2020-01-09 23:38:58",
        "desc": "1. 储值成功后，不可退款，请根据自己的消费情况充值。\n2. 储值余额不可提现，不可转移、转赠。\n3. 储值金额按国家法律、法规开具符合规定的发票，后续凭储值余额消费时，不再开具发票。如需发票请至奈雪点单小程序个人中心联系客服。\n4. 储值不累计会员成长值、积分与宝石，订单消费时以实际订单支付金额累计会员成长值、积分与宝石。\n5. 储值余额可在奈雪的茶内地线下门店、奈雪酒屋全国门店、奈雪点单小程序在线支付使用。",
        "store_id": 23107,
        "gifts": [],
        "type": 0,
        "full_image": "https://img-shop.qmimg.cn/s1000106/2018/07/09/cfbc38cae535a8ad8a.jpeg",
        "name": "800元",
        "sell_price": "800.00"
    }
]
